export default "__VITE_ASSET__bUxRh725__"